import { render, staticRenderFns } from "./KnowledgeBaseDetail.vue?vue&type=template&id=7215a62b&scoped=true"
import script from "./KnowledgeBaseDetail.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseDetail.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseDetail.vue?vue&type=style&index=0&id=7215a62b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7215a62b",
  null
  
)

export default component.exports